<template>
  <div class="h5bg">
    <div style="height: 10px;"></div>
    <div v-if="pmid != 219" style="padding:20px;background-color: #fff; margin:0 10px; border-radius: 6px;">
      <el-form ref="form" :model="enterInfo" label-position="top" label-width="180px">
        <el-form-item label="企业名称" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.firm_name" @blur="checkTyc" placeholder="请输入企业全称"></el-input>
        </el-form-item>

        <el-form-item label="工作详细地址" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.address" placeholder="请输入工作详细地址"></el-input>
        </el-form-item>

        <el-form-item label="企业联系人" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.firm_principal" placeholder="请输入企业联系人"></el-input>
        </el-form-item>
        <el-form-item label="企业联系人电话" style="margin-bottom: 0;" required>
          <el-input type="number" v-model="enterInfo.tel" placeholder="请输入企业联系人电话,请输入数字"></el-input>
        </el-form-item>

        <el-form-item label="是否参加校园企业宣讲会" style="margin-bottom: 0;" required>
          <el-radio-group v-model="enterInfo.pjson.xjh">
            <el-radio label="参加">参加</el-radio>
            <el-radio label="不参加">不参加</el-radio>
            <el-radio label="不确定">不确定</el-radio>
          </el-radio-group>
        </el-form-item>

        <div style="padding-top: 10px;"><span style="color:orangered">*</span>岗位信息</div>
        <div style="border: 1px solid #eee; padding:10px;margin-top: 10px; position: relative;"
          v-for="(pos, i) in job_info_list" :key="i">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="提供岗位名称" style="margin-bottom: 0;">
                <el-input v-model="pos.post" placeholder="岗位名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对应专业及层次" style="margin-bottom: 0;">
                <el-input v-model="pos.culture" placeholder="填专业或学历"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="男生人数" style="margin-bottom: 0;">
                <el-input v-model="pos.boy" type="number" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="女生人数" style="margin-bottom: 0;">
                <el-input type="number" v-model="pos.girl" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="实习津贴（元/月）" style="margin-bottom: 0;">
                <el-input v-model="pos.jintie" placeholder="填数字或范围"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="定岗工资（元/月）" style="margin-bottom: 0;">
                <el-input v-model="pos.salary" placeholder="填数字或范围"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div style="height: 10px;"></div>

          <div class="add" v-if="i == job_info_list.length - 1 && !loading" @click="addJob">
            <img :src="'./img/add_blue.png'" />
          </div>

          <div class="remove" v-if="job_info_list.length > 1 && !loading" @click="removeJob(i)">
            <img :src="'./img/remove.png'" />
          </div>

        </div>

        <el-form-item v-if="pmid == 216" label="上传图片" required>
          <div style="margin-left:0px;margin-bottom:8px;font-size:14px;line-height:20px;color:#909399">
            请上传营业执照和企业相关照片（办公场所、宿舍、食堂）</div>
          <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
            v-for="(img, idx) in fileList" :key="idx">
            <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
              :preview-src-list="[img.fileUrl || img.src]" img="cover"></el-image>

            <div class="imgremove" @click="removeImg(idx)"><i class="el-icon-remove"></i></div>
          </div>

          <div style="display:inline-block;vertical-align: top;">

            <el-upload style="display: inline-block; margin-right: 20px" action="" :http-request="uploadOss"
              :on-success="uploadFiles" :show-file-list="false" name="image" accept="image/png, image/jpeg">
              <div class="imgaddbtn">
                ＋
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <div>
          <el-button v-if="!loading" type="primary" @click="saveForm" :loading="loading"
            style="width: 100%; margin-top: 50px; margin-bottom: 50px;">提交登记</el-button>
        </div>


      </el-form>


    </div>
    <div v-if="pmid==219" style="padding:20px;background-color: #fff; margin:0 10px; border-radius: 6px;">

      <div style="font-size:12px;">说明：
        <div style="font-size:12px;color:#909399;">一、岗位名称原则参照职业技能岗位名称填写；</div>
        <div style="font-size:12px;color:#909399;">二、学校信息：</div>
        <div style="font-size:12px;color:#909399;">（一）联系地址：靖江市职业技能公共实训中心（靖江市阜前路95号）7A105实训处办公室；</div>
        <div style="font-size:12px;color:#909399;">（二）联系人：赵焰平（13295238758、89165166）
          王晶（18961033598、89165266）。</div>
      </div>
      <el-form ref="form" :model="enterInfo" label-position="top" label-width="180px">
        <el-form-item label="企业名称" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.firm_name" @blur="checkTyc" placeholder="请输入企业全称"></el-input>
        </el-form-item>
        <el-form-item label="员工总数" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.pjson.staff_num" type="number" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item label="单位地址" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.address" placeholder="请输入单位地址"></el-input>
        </el-form-item>

        <el-form-item label="联系人姓名" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.firm_principal" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人移动电话" style="margin-bottom: 0;" required>
          <el-input type="number" v-model="enterInfo.tel" placeholder="请输入联系人电话,请输入数字"></el-input>
        </el-form-item>
        <el-form-item label="联系人QQ号" style="margin-bottom: 0;" required>
          <el-input type="number" v-model="enterInfo.pjson.qq" placeholder="请输入联系人QQ号,请输入数字"></el-input>
        </el-form-item>
        <el-form-item label="联系人微信号" style="margin-bottom: 0;" required>
          <el-input v-model="enterInfo.pjson.wx" placeholder="请输入联系人微信号"></el-input>
        </el-form-item>

        <!-- <el-form-item label="是否参加校园企业宣讲会" style="margin-bottom: 0;" required>
          <el-radio-group v-model="enterInfo.pjson.xjh">
            <el-radio label="参加">参加</el-radio>
            <el-radio label="不参加">不参加</el-radio>
            <el-radio label="不确定">不确定</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <div style="padding-top: 10px;"><span style="color:orangered">*</span>岗位信息</div>
        <div style="border: 1px solid #eee; padding:10px;margin-top: 10px; position: relative;"
          v-for="(pos, i) in job_info_list" :key="i">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="提供岗位名称" style="margin-bottom: 0;">
                <el-input v-model="pos.post" placeholder="岗位名称"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="对应专业及层次" style="margin-bottom: 0;">
                <el-input v-model="pos.culture" placeholder="填专业或学历"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="岗位员工数" style="margin-bottom: 0;">
                <el-input v-model="pos.staff_num" type="number" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="实习人数" style="margin-bottom: 0;">
                <el-input type="number" v-model="pos.sx_num" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="实习津贴（元/月）" style="margin-bottom: 0;">
                <el-input v-model="pos.jintie" placeholder="填数字或范围"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="定岗工资（元/月）" style="margin-bottom: 0;">
                <el-input v-model="pos.salary" placeholder="填数字或范围"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <div style="height: 10px;"></div>

          <div class="add" v-if="i == job_info_list.length - 1 && !loading" @click="addJob">
            <img :src="'./img/add_blue.png'" />
          </div>

          <div class="remove" v-if="job_info_list.length > 1 && !loading" @click="removeJob(i)">
            <img :src="'./img/remove.png'" />
          </div>

        </div>

        <el-form-item v-if="pmid == 216" label="上传图片" required>
          <div style="margin-left:0px;margin-bottom:8px;font-size:14px;line-height:20px;color:#909399">
            请上传营业执照和企业相关照片（办公场所、宿舍、食堂）</div>
          <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
            v-for="(img, idx) in fileList" :key="idx">
            <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
              :preview-src-list="[img.fileUrl || img.src]" img="cover"></el-image>

            <div class="imgremove" @click="removeImg(idx)"><i class="el-icon-remove"></i></div>
          </div>

          <div style="display:inline-block;vertical-align: top;">

            <el-upload style="display: inline-block; margin-right: 20px" action="" :http-request="uploadOss"
              :on-success="uploadFiles" :show-file-list="false" name="image" accept="image/png, image/jpeg">
              <div class="imgaddbtn">
                ＋
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <div>
          <el-button v-if="!loading" type="primary" @click="saveForm" :loading="loading"
            style="width: 100%; margin-top: 50px; margin-bottom: 50px;">提交登记</el-button>
        </div>


      </el-form>


    </div>

    <div style="height:20px"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      openid: "asfljasfjdasldjfasklf",
      pmid: 0,
      loading: false,

      enterInfo: {
        firm_name: "",
        firm_num: "",
        address: "",
        firm_principal: "",
        tel: "",
        pjson: {
          xjh: ""
        }
      },
      zphid: 0,
      job_info_list: [],
      job: { "post": "", "num": 3, boy: "", girl: "", "specialty": "", "culture": "", "foreignLanguage": "", "computer": "", jintie: "", salary: "" },
      fileList: [],

    };
  },
  mounted() {
    let _this = this
    if (window.pmid == 208) {
      document.title = "江阴中专校园双选会参会企业登记表"
    }
    if (window.pmid == 219) {
      document.title = "靖江中专校园双选会参会登记表"
    }

    this.openid = this.$route.query.openid
    this.pmid = this.$route.query.pmid

    this.$nextTick(() => {
      _this.$forceUpdate()
    })
    this.getList()

  },
  methods: {


    getList() {
      this.$http.post("/api/get_enter_info_byopenid", { pmid: this.pmid, openid: this.openid }).then(res => {
        if (res.data) {
          let enterInfo = res.data
          if (res.data.zph) {
            this.job_info_list = JSON.parse(res.data.zph.job_info_list)
            enterInfo.pjson = JSON.parse(res.data.zph.pjson)
            this.zphid = res.data.zph.id
          } else {
            this.job_info_list = [{ ...this.job }]
            enterInfo.pjson = {
              xjh: ""
            }
          }
          if (res.data.files) {
            this.fileList = JSON.parse(res.data.files)
          }
          this.enterInfo = enterInfo

        } else {
          this.job_info_list = [{ ...this.job }]

        }
      })
    },
    addJob() {
      this.job_info_list.push({ ...this.job })
      this.$nextTick(e => {
        $(".h5bg").scrollTop(99999)
      })
    },
    removeJob(i) {
      this.job_info_list.splice(i, 1)
    },
    checkTyc() {
      this.$http.post("/api/tyc_search", { enter_name: this.enterInfo.firm_name }).then(res => {
        if (res.data) {
          this.enterInfo.firm_name = res.data.name
          this.enterInfo.address = res.data.regLocation
          this.enterInfo.firm_num = res.data.creditCode
        }
      })
    },
    uploadFiles(e) {
      this.fileList.push(e)
    },
    removeImg(idx) {
      this.fileList.splice(idx, 1)
    },
    checkEnterSuccess() {
      
    },
    
    saveForm() {
      if (!this.enterInfo.firm_name.trim()) {
        this.$message({
          message: "请输入企业全称",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.address.trim()) {
        this.$message({
          message: "请输入真实工作地址",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.firm_principal.trim()) {
        this.$message({
          message: "请输入企业联系人",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.tel.trim()) {
        this.$message({
          message: "请输入企业联系人电话",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      // if (!this.enterInfo.pjson.xjh) {
      //   this.$message({
      //     message: "请选择是否参与企业宣讲会",
      //     type: 'error',
      //     customClass: "toast",
      //     duration: 2000
      //   });
      //   return
      // }

      //检查岗位有没有填写
      let jobok = false
      for (let job of this.job_info_list) {

        if (this.pmid!=219&&(!job.post || !job.culture || !job.jintie || !job.salary)) {
          this.$message({
            message: "请完善岗位信息",
            type: 'error',
            customClass: "toast",
            duration: 2000
          });
          return
        }
        if (this.pmid == 219 && (!job.post || !job.staff_num || !job.sx_num)) {
          this.$message({
            message: "请完善岗位信息",
            type: 'error',
            customClass: "toast",
            duration: 2000
          });
          return
        }
      }
      if (this.pmid == 216 && (!this.fileList || this.fileList.length == 0)) {
        this.$message({
          message: "请上传营业执照和企业相关照片（办公场所、宿舍、食堂）",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      this.loading = true
      let data = { ...this.enterInfo }
      data.job_info_list = this.job_info_list
      data.pjson = this.enterInfo.pjson
      data.pmid = this.pmid
      data.openid = this.openid
      data.id = this.enterInfo.id
      data.zphid = this.zphid
      data.files = JSON.stringify(this.fileList)
      this.$http.post("/api/h5_enterprise_dengji", data).then(res => {
        this.$message({
          message: "信息登记成功，感谢您的参与！",
          type: 'success',
          customClass: "toast",
          duration: 5000
        });
        this.loading = false
        this.getList()

      })


    }

  }

};
</script>

<style scoped>
.h5bg {
  background-image: url(../../../public/img/xiantiao.jpg);
  background-size: 100% 100%;
  height: 100vh;
  overflow: auto;

}

.remove {
  width: 30px;
  height: 30px;
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
}

.remove img {
  width: 100%;
  height: 100%;
}

.add {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.add img {
  width: 100%;
  height: 100%;
}
</style>

<style>
.el-form--label-top .el-form-item__label {
  margin-bottom: 0;
  padding: 0;
}

.toast {
  width: 80%;
  min-width: 10% !important;
  max-width: 350px !important;
}

.imgaddbtn {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dotted #ccc;
  font-size: 30px;
  cursor: pointer;
}

.imgremove {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;

  cursor: pointer;
  position: absolute;
  top: -5px;
  right: -5px;
  color: #ccc;
}

.imgremove:hover {
  color: orange;
}
</style>